import Swal from "sweetalert2";
import { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../Provider/AuthProvider";
import AdminNavbar from "../../Components/AdminNavbar/AdminNavbar";
import TextEditor from "../../Components/TextEditor/TextEditor";
import Footer from "../../../components/footer/Footer";
import { BiSolidHome } from "react-icons/bi";

const AddNewProducts = () => {
  const { user } = useContext(AuthContext);
  const [sections, setSections] = useState([{ title: "", content: "" }]);

  const handleSectionTitleChange = (index, title) => {
    const updated = [...sections];
    updated[index].title = title;
    setSections(updated);
  };

  const handleSectionContentChange = (index, html) => {
    const updated = [...sections];
    updated[index].content = html;
    setSections(updated);
  };

  const addSection = () => {
    setSections([...sections, { title: "", content: "" }]);
  };

  const removeSection = (index) => {
    const updated = [...sections];
    updated.splice(index, 1);
    setSections(updated);
  };
  // States to hold uploaded image URLs
  const [productDetailsPhotoUrl, setProductDetailsPhotoUrl] = useState("");
  const [photo1Url, setPhoto1Url] = useState("");
  const [photo2Url, setPhoto2Url] = useState("");
  const [photo3Url, setPhoto3Url] = useState("");
  const [photo4Url, setPhoto4Url] = useState("");

  const imgbbApiKey = "372772eac972cb5bc94f6a3995c54b8e";

  // ✅ Generic function to upload to ImgBB and return URL
  const uploadImageToImgBB = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch(
      `https://api.imgbb.com/1/upload?key=${imgbbApiKey}`,
      {
        method: "POST",
        body: formData,
      }
    );
    const data = await res.json();
    if (data.success) {
      return data.data.url;
    } else {
      throw new Error("Image upload failed");
    }
  };

  // ✅ SweetAlert2 success popup
  const showSuccessAlert = (title, text = "") =>
    Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "swal-confirm-button-success",
      },
      buttonsStyling: false,
    });

  // ❌ SweetAlert2 error popup
  const showErrorAlert = (title, text = "") =>
    Swal.fire({
      title,
      text,
      icon: "error",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "swal-confirm-button-error",
      },
      buttonsStyling: false,
    });

  // ✅ Handlers for each image upload input
  const handleProductDetailsPhotoChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const url = await uploadImageToImgBB(file);
      setProductDetailsPhotoUrl(url);
      showSuccessAlert("✅ Product details photo uploaded!");
    } catch (error) {
      showErrorAlert("❌ Failed to upload Product details photo.");
    }
  };

  const handlePhoto1Change = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const url = await uploadImageToImgBB(file);
      setPhoto1Url(url);
      showSuccessAlert("✅ Photo 1 uploaded!");
    } catch (error) {
      showErrorAlert("❌ Failed to upload Photo 1.");
    }
  };

  const handlePhoto2Change = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const url = await uploadImageToImgBB(file);
      setPhoto2Url(url);
      showSuccessAlert("✅ Photo 2 uploaded!");
    } catch (error) {
      showErrorAlert("❌ Failed to upload Photo 2.");
    }
  };

  const handlePhoto3Change = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const url = await uploadImageToImgBB(file);
      setPhoto3Url(url);
      showSuccessAlert("✅ Photo 3 uploaded!");
    } catch (error) {
      showErrorAlert("❌ Failed to upload Photo 3.");
    }
  };

  const handlePhoto4Change = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    try {
      const url = await uploadImageToImgBB(file);
      setPhoto4Url(url);
      showSuccessAlert("✅ Photo 4 uploaded!");
    } catch (error) {
      showErrorAlert("❌ Failed to upload Photo 4.");
    }
  };

  const handleRemovePhoto = (e, setPhotoUrl, inputId) => {
    e.preventDefault();
    e.stopPropagation();
    setPhotoUrl("");
    if (inputId) {
      const inputElem = document.getElementById(inputId);
      if (inputElem) inputElem.value = "";
    }
  };

  const userName = user?.displayName || "";
  const userEmail = user?.email || "";

  // ✅ Form submission handler
  const handleAddWork = async (event) => {
    event.preventDefault();
    const form = event.target;
    const Product_name = form.Product_name.value;
    const Pack_Size = form.Pack_Size.value;
    const brand_Name = form.brand_Name.value;
    const product_Category = form.product_Category.value;
    const Net_Wt = form.Net_Wt.value;
    const Gross_Wt = form.Gross_Wt.value;
    const Carton_Dim = form.Carton_Dim.value;

    if (!productDetailsPhotoUrl) {
      return showErrorAlert(
        "❌ Error",
        "Please upload all required images first."
      );
    }

    const stripHtml = (html) => {
      const tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    };

    const hasEmptyContent = sections.some(
      (s) => !s.title.trim() || !stripHtml(s.content).trim()
    );
    if (hasEmptyContent) {
      return showErrorAlert(
        "❌ Error",
        "Please fill out all rich text sections."
      );
    }

    const newProduct = {
      user_name: userName,
      user_email: userEmail,
      Product_name,
      Pack_Size,
      brand_Name,
      product_Category,
      Net_Wt,
      Gross_Wt,
      Carton_Dim,
      Product_Details_Photo: productDetailsPhotoUrl,
      photo1: photo1Url,
      photo2: photo2Url,
      photo3: photo3Url,
      photo4: photo4Url,
      richTexts: sections,
      createdAt: new Date(),
    };

    try {
      const response = await fetch(
        "https://backend-server-nine-opal.vercel.app/contents",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          // credentials: "include",
          body: JSON.stringify(newProduct),
        }
      );

      const result = await response.json();

      if (result.insertedId || result.id) {
        showSuccessAlert("✅ Success", "Product info saved successfully!").then(
          () => {
            window.location.reload();
          }
        );

        // Clear uploaded URLs state
        setProductDetailsPhotoUrl("");
        setPhoto1Url("");
        setPhoto2Url("");
        setPhoto3Url("");
        setPhoto4Url("");
      } else {
        throw new Error("Failed to save");
      }
    } catch (error) {
      console.error("Save error:", error);
      showErrorAlert("❌ Error", "Failed to save product. Please try again.");
    }
  };

  return (
    <div>
      <AdminNavbar />
      <div className="container mx-auto" style={{ textAlign: "left" }}>
        <div className="">
          <div className="text-sm px-4 breadcrumbs">
            <ul>
              <li>
                <Link to="/">
                  <BiSolidHome className="text-lg" />
                  <span className="flex items-center">Home</span>
                </Link>
              </li>
              <li>
                <Link to="/dashboard">
                  <span className="flex items-center">Dashboard</span>
                </Link>
              </li>
              <li>Add Product Info</li>
            </ul>
          </div>
          <div className="mx-auto bg-[#e7e7e7] mt-4 lg:p-16 p-4 rounded-2xl">
            <h1 className="lg:text-3xl text-xl text-center font-bold text-gray-900">
              Add New Product Info
            </h1>
            <form className="py-6" onSubmit={handleAddWork}>
              <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    User Name
                  </label>
                  <div className="mt-2.5">
                    <input
                      disabled
                      type="text"
                      defaultValue={userName}
                      name="user_name"
                      placeholder="Enter tourist spot name"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    User Email
                  </label>
                  <div className="mt-2.5">
                    <input
                      disabled
                      type="text"
                      defaultValue={userEmail}
                      name="user_email"
                      placeholder="Enter Email name"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Product Name
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="Product_name"
                      placeholder="Enter Product name"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Pack Size
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="Pack_Size"
                      placeholder="Enter Pack Size"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Brand Name
                  </label>
                  <div className="mt-2.5">
                    <select
                      name="brand_Name"
                      defaultValue="Select A Category"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option disabled>Select A Brand</option>
                      <option value="Crown Farms">Crown Farms</option>
                      <option value="Rosemco">Rosemco</option>
                      <option value="Zoy">Zoy</option>
                      <option value="Saidowla">Saidowla</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Product Category
                  </label>
                  <div className="mt-2.5">
                    <select
                      name="product_Category"
                      defaultValue="Select A Category"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    >
                      <option value="Snacks">Snacks</option>
                      <option value="Fish">Fish</option>
                      <option value="Paratha">Paratha</option>
                      <option value="Vegetables">Vegetables</option>
                      <option value="Bakery & Sweets">Bakery & Sweets</option>
                    </select>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Net Wt. (Kg)
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="Net_Wt"
                      placeholder="Enter Net Wt. (Kg)"
                      className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Gross Wt. (Kg)
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="Gross_Wt"
                      placeholder="Enter Gross Wt. (Kg)"
                      className=" w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Carton Dim. (cm) L x W x H
                  </label>
                  <div className="mt-2.5">
                    <input
                      type="text"
                      name="Carton_Dim"
                      placeholder="Enter Carton Dim. (cm) L x W x H"
                      className=" w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                {/* ✅ Image Uploads */}
                <div className="sm:col-span-2">
                  <label className="block text-sm font-semibold leading-6 text-gray-900">
                    Product Photos
                  </label>

                  <div className="mt-3 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                    {/* Product Details Photo (Main Required) */}
                    <div className="flex flex-col items-center p-3 border rounded-lg shadow-sm bg-gray-50">
                      <input
                        type="file"
                        id="productDetailsPhoto"
                        className="hidden"
                        onChange={(e) =>
                          handleProductDetailsPhotoChange(
                            e,
                            setProductDetailsPhotoUrl
                          )
                        }
                      />
                      <div className="relative w-full h-28">
                        <label
                          htmlFor="productDetailsPhoto"
                          className="cursor-pointer flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-gray-300 rounded-lg hover:border-indigo-500 overflow-hidden"
                        >
                          {productDetailsPhotoUrl ? (
                            <img
                              src={productDetailsPhotoUrl}
                              alt="Product Details"
                              loading="lazy"
                              className="h-24 w-full object-cover rounded-lg"
                            />
                          ) : (
                            <span className="text-gray-500 text-sm text-center">
                              Upload Main Photo
                            </span>
                          )}
                        </label>
                        {productDetailsPhotoUrl && (
                          <button
                            type="button"
                            title="Remove photo"
                            onClick={(e) =>
                              handleRemovePhoto(
                                e,
                                setProductDetailsPhotoUrl,
                                "productDetailsPhoto"
                              )
                            }
                            className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 shadow-md transition z-10"
                          >
                            <svg
                              className="w-4 h-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                              />
                            </svg>
                          </button>
                        )}
                      </div>
                      <h2>Main Photo</h2>
                    </div>

                    {/* Extra Photos 1 to 4 */}
                    {[
                      {
                        id: "photo1",
                        title: "Extra Photo 01",
                        label: "Upload Photo 1",
                        url: photo1Url,
                        setUrl: setPhoto1Url,
                        onChange: (e) => handlePhoto1Change(e, setPhoto1Url),
                      },
                      {
                        id: "photo2",
                        title: "Extra Photo 02",
                        label: "Upload Photo 2",
                        url: photo2Url,
                        setUrl: setPhoto2Url,
                        onChange: (e) => handlePhoto2Change(e, setPhoto2Url),
                      },
                      {
                        id: "photo3",
                        title: "Extra Photo 03",
                        label: "Upload Photo 3",
                        url: photo3Url,
                        setUrl: setPhoto3Url,
                        onChange: (e) => handlePhoto3Change(e, setPhoto3Url),
                      },
                      {
                        id: "photo4",
                        title: "Extra Photo 04",
                        label: "Upload Photo 4",
                        url: photo4Url,
                        setUrl: setPhoto4Url,
                        onChange: (e) => handlePhoto4Change(e, setPhoto4Url),
                      },
                    ].map((item) => (
                      <div
                        key={item.id}
                        className="flex flex-col items-center p-3 border rounded-lg shadow-sm bg-gray-50"
                      >
                        <input
                          type="file"
                          id={item.id}
                          className="hidden"
                          onChange={item.onChange}
                        />
                        <div className="relative w-full h-28">
                          <label
                            htmlFor={item.id}
                            className="cursor-pointer flex flex-col items-center justify-center w-full h-28 border-2 border-dashed border-gray-300 rounded-lg hover:border-indigo-500 overflow-hidden"
                          >
                            {item.url ? (
                              <img
                                src={item.url}
                                alt={item.title}
                                loading="lazy"
                                className="h-24 w-full object-cover rounded-lg"
                              />
                            ) : (
                              <span className="text-gray-500 text-sm text-center">
                                {item.label}
                              </span>
                            )}
                          </label>
                          {item.url && (
                            <button
                              type="button"
                              title="Remove photo"
                              onClick={(e) =>
                                handleRemovePhoto(e, item.setUrl, item.id)
                              }
                              className="absolute -top-2 -right-2 bg-red-500 hover:bg-red-600 text-white rounded-full p-1 shadow-md transition z-10"
                            >
                              <svg
                                className="w-4 h-4"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  strokeWidth={2}
                                  d="M6 18L18 6M6 6l12 12"
                                />
                              </svg>
                            </button>
                          )}
                        </div>
                        <h2>{item.title}</h2>
                      </div>
                    ))}
                  </div>
                </div>

                {/* ✅ Text Editor */}
                <div className="sm:col-span-2">
                  <label className="block font-semibold text-gray-900 mb-4">
                    Product Details Sections
                  </label>

                  {sections.map((section, index) => (
                    <div
                      key={index}
                      className="border p-4 mb-6 rounded-md bg-white"
                    >
                      <h1 className="text-lg font-semibold">Tab Name</h1>
                      <div className="flex justify-between items-center">
                        <input
                          type="text"
                          placeholder="Section Title (e.g.: Nutritional Information, Specifications, Allergen Advice)"
                          className="w-full border rounded-md px-3 py-2 mb-2 text-sm"
                          value={section.title}
                          onChange={(e) =>
                            handleSectionTitleChange(index, e.target.value)
                          }
                        />
                        {sections.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeSection(index)}
                            className="ml-2 text-red-500 hover:underline text-sm"
                          >
                            Remove
                          </button>
                        )}
                      </div>
                      <h1 className="text-lg font-semibold">Content</h1>
                      <TextEditor
                        onChange={(html) =>
                          handleSectionContentChange(index, html)
                        }
                        initialContent={section.content}
                      />
                    </div>
                  ))}

                  <button
                    type="button"
                    onClick={addSection}
                    className="mt-2 px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700"
                  >
                    + Add New Section
                  </button>
                </div>
              </div>
              <div className="mt-10">
                <button
                  type="submit"
                  value="Add Product"
                  className="block w-full rounded-md  px-3.5 py-2.5 text-center text-sm font-semibold text-white bg-[#55D4AB] hover:bg-[#f0ca4e] hover:text-black "
                >
                  Add Product
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default AddNewProducts;
